<div class="modal fade" id="searchHelp" tabindex="-1" role="dialog"
     [ngClass]="{'show': isSearchHelpModalShown}" [ngStyle]="{'display': displaySearchHelpModal}">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content dk-search-help-content">
      <div class="modal-header dk-search-help-header">
        <h6 class="modal-title" id="addRelationship">{{searchHelp?.OBJECT_NAME}} ({{listData.length}})</h6>
        <button type="button" class="close" (click)="closeSearchHelpModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="isFilterShown" class="card mb-2">
          <div *ngIf="searchHelp && searchHelp.FUZZY_SEARCH" class="mt-2 mx-2 row">
            <input type="text" class="form-control" placeholder="Search" [(ngModel)]="fuzzySearchTerm" (keyup)="enterSearch($event)">
          </div>
          <div class="mt-2 mx-2 row" [formGroup]="filterFieldsFormGroup">
            <div *ngFor="let filterField of filterFields" class="col-6 form-group row">
              <label for="{{filterField.FIELD_NAME}}" class="col-6 col-form-label col-form-label-sm text-right">
                {{filterField.LABEL_TEXT || filterField.FIELD_NAME}}:</label>
              <input id="{{filterField.FIELD_NAME}}" name="{{filterField.FIELD_NAME}}" formControlName="{{filterField.FIELD_NAME}}"
                     type="text" class="col-6 form-control form-control-sm" [readonly]="filterField.FILTER_DISP_ONLY" (keyup)="enterSearch($event)">
            </div>
          </div>

          <div class="mb-2">
            <button type="button" id="search" class="btn btn-sm btn-primary float-right mr-2" (click)="search()">
              Search
            </button>
          </div>
        </div>

        <button *ngIf="!isFilterShown" type="button" class="btn btn-link float-right" (click)="showFilter()">Show Filter</button>
        <button *ngIf="isFilterShown" type="button" class="btn btn-link float-right" (click)="hideFilter()">Hide Filter</button>

        <table class="table table-bordered table-sm table-hover dk-search-table">
          <thead class="thead-light">
          <tr>
            <th scope="col">
              <input *ngIf="searchHelp?.MULTI" type="checkbox" [(ngModel)]="isSelectAllChecked" (click)="selectAll()">
            </th>
            <th *ngFor="let listField of listFields"
                [style.display]="listField.FIELD_NAME === 'INSTANCE_GUID' ? 'none' : 'table-cell'">
              {{listField.LIST_HEADER_TEXT || listField.FIELD_NAME}}
            </th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let item of listData; let i = index">
            <td>
              <input *ngIf="!searchHelp.MULTI" type="radio" name="selectedIndex" [value]="i" [(ngModel)]="selectedIndex" (dblclick)="confirmSelection()">
              <input *ngIf="searchHelp.MULTI" type="checkbox" [(ngModel)]="item.SELECTED">
            </td>
            <td *ngFor="let listField of listFields"
                [style.display]="listField.FIELD_NAME === 'INSTANCE_GUID' ? 'none' : 'table-cell'">
              {{item[listField.FIELD_NAME]}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer dk-search-help-footer">
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeSearchHelpModal()">Cancel</button>
        <button type="button" class="btn btn-sm btn-primary" (click)="confirmSelection()" [disabled]="searchHelp?.READ_ONLY">Confirm</button>
      </div>
    </div>
  </div>
</div>
